type BrandedLoaderProps = {
  compact?: boolean;
  label?: string;
};

export function BrandedLoader({ compact = false, label }: BrandedLoaderProps) {
  return (
    <div
      className={compact ? "flex items-center justify-center px-4 py-10" : "flex min-h-[calc(100svh-8rem)] items-center justify-center px-4 py-16"}
      role="status"
      aria-label={label ?? "Please wait"}
    >
      <div className="flex flex-col items-center gap-5 text-center">
        <div className="loader-mark" aria-hidden="true">
          <span className="loader-mark__ring" />
          <span className="loader-mark__orbit" />
          <img src="/medopilot-icon.png" alt="" className="loader-mark__icon" />
        </div>
        {label ? <p className="text-sm font-medium text-muted-foreground">{label}</p> : null}
      </div>
    </div>
  );
}
